/*
  import { vendorContact } from '@/services/Vendors/VendorContacts/store'
*/

import Vue from 'vue'
import Vuex from 'vuex'

import { notifyProblem } from '@/services/notify'
import kms from '@/services/kms'

const isDebug = true

/* eslint-disable no-empty-pattern */
const actions = {
  /*
    const { list } = await vendorContact.dispatch ('getVendorContactList', {
      vendorID
    });
  */
  async getVendorContactList({}, { vendorID }) {
    console.log('in getVendorContactList...')
    try {
      const result = await kms.get('/Vendors/VendorContact/List', {
        params: {
          vendorID
        }
      })

      if (isDebug == true) console.debug('getVendorContactList log=' + JSON.stringify(result))

      return {
        list: result.results
      }
    } catch (exception) {
      notifyProblem(`The vendor contacts list could not be retrieved.`)
      console.error(exception)
    }

    return {
      list: []
    }
  }
}
/* eslint-enable no-empty-pattern */

Vue.use(Vuex)
export const vendorContact = new Vuex.Store({
  state: {},
  mutations: {},
  getters: {},
  actions
})
